<ion-col size-sm="12" size-xs="12" size-md="12" size-lg="6" sizeXl="4">
    <ion-card>
      <div class="goals-title">
        Doelen
      </div>
      <ion-row>
        <ion-col size="12" class="goals-text">
          In dit gedeelte van de app kunt u de status inzien van de door u ingegeven doelen. Ziet u geen doel? Vul dan de gegevens in.
        </ion-col>

        <ng-container *ngFor="let goal of goals">
          <div class="goals-card card-container" *ngIf="goal.months_left == 0">
            <div class="card-item">
              <i class="fas fa-plane"></i>
              <h2>{{goal.name}}</h2>
              <p>{{goal.months_left}} months total</p>
              <strong>{{formatter.formatMoney(goal.value)}}</strong>
            </div>
            <div class="card-item">
              <i class="fas fa-check"></i>
            </div>
          </div>

          <div class="goals-card card-container" *ngIf="goal.months_left != 0">
            <div class="card-item">
              <i class="fas fa-plane"></i>
              <h2>{{goal.name}}</h2>
              <p>{{goal.months_left}} maanden totaal</p>
              <strong>{{formatter.formatMoney(goal.value)}}</strong>&nbsp;<span>{{formatter.formatMoney(goal.needed_per_month)}} p/m</span>
            </div>
            <div class="card-item">
                <i class="fas fa-euro-sign"></i>
                <circle-progress 
                    [percent]="goal.months_left / goal.months_total"
                    [radius]="35"
                    [outerStrokeWidth]="3"
                    [innerStrokeWidth]="0"
                    [outerStrokeColor]="'#FFFFFF'"
                    [innerStrokeColor]="'#C7E596'"
                    [animation]="true"
                    [showUnits]="false"
                    [showTitle]="false"
                    [showSubtitle]="false"
                    [animation]="true"
                    [animationDuration]="300"
                    class="circle-progress"
                ></circle-progress>
            </div>
          </div>
        </ng-container>
      </ion-row>
    </ion-card>
  </ion-col>
